import type { CategorieDto } from "@/types/categorie.types";

// Normalise pour comparer sans tenir compte des accents/casse ("Éducation" ~ "education").
function normaliser(valeur: string) {
  return valeur.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/**
 * "Éducation aux médias" est une catégorie à part entière, gérée en admin —
 * ne jamais coder son slug en dur (ça la confond avec "Décryptages", qui est
 * un tout autre contenu). On la reconnaît par son libellé, normalisé.
 */
export function estCategorieEducation(c: Pick<CategorieDto, "libelleFr" | "libelleEn">): boolean {
  return (
    normaliser(c.libelleFr || "").includes("education aux medias") ||
    normaliser(c.libelleEn || "").includes("media literacy")
  );
}
